// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1qhqze3t >:not(.fabric-editor-block-mark) h1, ._1jzaze3t >:not(.fabric-editor-block-mark) h2, ._1bgsze3t >:not(.fabric-editor-block-mark) h3, ._9b1aze3t >:not(.fabric-editor-block-mark) h4, ._cog4ze3t >:not(.fabric-editor-block-mark) h5, ._1gbhze3t >:not(.fabric-editor-block-mark) h6{margin-top:var(--ds-space-0,0)}", ""]);
// Exports
module.exports = exports;
